import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
export var HeatmapWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  ", "\n"], ["\n  width: 100%;\n  height: 100%;\n  ",
    "\n"])), function (props) {
    return props.isHidden && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      visibility: hidden;\n      position: absolute;\n    "], ["\n      visibility: hidden;\n      position: absolute;\n    "])));
});
var templateObject_1, templateObject_2;
